(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["featured-product-lpd"] && !Shopify.designMode) return;
  try {
    

    var selected_variant = '';
  $('.quantity-discount__option').click(function(){
    $('.quantity-discount__option').removeClass('quantity-discount_selected');
    $(this).addClass('quantity-discount_selected');

    var selected_quantity = $(this).attr('data-value');
    selected_variant = $(this).attr('data-variant');
    $('.quantity_selector-qty').val(selected_quantity);
    $('.quantity_product').val(selected_variant);
  });

   $(document).on("click",".quantity-discount__buy-now", function(e){
    e.preventDefault()
      $(this).text('Processing...');

      $.ajax({
        type: "POST",
        url: '/cart/clear.js',
        success: function(){
          add_to_cart();
        },
        dataType: 'json'
      });

      function add_to_cart(){
        var radio_name = $('.bottle-field.bottle-active').find('input').data('name');
        if(radio_name == 'Radio'){
          var id = $('#radio').data('variant');
          var sellingPlanId = $('.frequency-1-bottle').find('select :selected').val();
        }else if(radio_name == 'Radio 3'){
          var id = $('#radio-3').data('variant');
          var sellingPlanId = $('.frequency-2-bottle').find('select :selected').val();
        }else{
          var id = $('#radio-2').data('variant');
          var sellingPlanId = $('.frequency-4-bottle').find('select :selected').val();
        }
        var text_name = $('.subscribe-field.subscribe-active').find('.w-form-label').text();
      if(text_name == 'Buy once'){
        data = {
                "quantity": 1,
                "id": id,
              };
      }else{
        data = {
                "quantity": 1,
                "id": id,
                "selling_plan": sellingPlanId,
              };
      }
    $.ajax({
            type: 'POST',
            url: '/cart/add.js',
            dataType: 'json',
            data: data,
            success: function(data) {
            window.location.href = '/checkout/';
            },
            error: function(){
              $('.quantity-discount__buy-now').text('Secure Checkout');
              }
        });
  }

  });
  
  } catch(e) { console.error(e); }
})();
})();
